export default __webpack_public_path__ + "f1617cf28b5c1892f409f9b1fb870e10.ttf";